import { normalizeGsm } from './normalizeGsm';

export const isOnlyAddressChanged = (record, values) => {
    const addressChanged = record?.addressId !== values?.addressId;
    if (!addressChanged) return false;

    const keys = Object.keys(values || {}).filter((k) => k !== 'addressId');
    for (const k of keys) {
        const val = values[k];
        const recVal = record?.[k];

        if (k === 'gsm') {
            const normVal = normalizeGsm(val || '') || '';
            const recGsm = (recVal || '')?.toString().replaceAll(/\D/g, '') || '';

            if (normVal !== recGsm) return false;
            continue;
        }

        if ((val ?? '') !== (recVal ?? '')) return false;
    }

    return true;
};

export default isOnlyAddressChanged;
